import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 24px 0 0 0;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const GroupLabel = styled.span`
  color: #64748B;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 21px;
  text-transform: uppercase;
  margin-bottom: 4px;
  padding: 0 32px;
`;

export const Divider = styled.hr`
  border: none;
  height: 1px;
  background-color: #64748B33;
  margin: 8px 32px 24px;
`;

export const VsImage = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid rgba(100, 116, 139, 0.40);
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    object-fit: contain;
  }
`;

export const Header = styled.div`
  padding: 0 32px;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const Category = styled.span`
  color: #112538;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
  word-break: break-word;
`;

export const Area = styled.span`
  padding: 2px 10px;
  border-radius: 16777200px;
  background: #F1F5F9;
  color: #64748B;
  font-family: Inter;
  font-size: 12px;
  line-height: 21px;
  word-break: break-word;
`;

export const Goal = styled.span`
  color: #64748B;
  font-family: Inter;
  font-size: 14px;
  line-height: 22px;
  width: 50%;
  word-break: break-word;
`;

export const Group = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  gap: 24px;

  ${({ theme }) => theme.max("md")`
    flex-direction: column;
  `}
`;

export const Col = styled.div`
  flex: 1;
  text-align: center;
  align-self: normal;

  &:first-child {
    margin-right: 8px;
  }

  &:last-child {
    margin-left: 8px;
  }
`;

export const VsText = styled.span`
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #64748B;
  text-align: center;
  font-family: Inter;
  font-size: 11.357px;
  border-radius: 50%;
  border: 1px solid rgba(100, 116, 139, 0.40);
`;
